
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[communityId]/[communitySlug]",
      function () {
        return require("private-next-pages/community/[communityId]/[communitySlug]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[communityId]/[communitySlug]"])
      });
    }
  